import React from "react";
import { doFetch } from "@action.sustainability/storybook-dashboard/utils/fetching";
import { postFetch } from "./utils";

export function ActionButton({ text, color, onClickHandler }) {
  return (
    <span
      className={`bg-${color || "primary"} rounded m-1 pl-1 pr-1 text-white`}
      style={{ cursor: "pointer" }}
      onClick={onClickHandler}
    >
      {text}
    </span>
  );
}

const respondInvite = (invite, accept) => {
  const companyId = invite.getIn(["company", "uid"]);
  const inviteId = invite.get("uid");
  const isRequest = invite.get("is_request");
  const data = {
    accepted: accept,
    rejected: !accept,
    company: { uid: companyId },
  };
  const url = isRequest
    ? `/api/company/${companyId}/invite/${inviteId}/`
    : `/api/company/invite/${inviteId}/`;
  postFetch(url, data, "PATCH").then(() => location.reload());
};

const deleteInvite = (invite) => {
  const inviteId = invite.get("uid");
  doFetch(`/api/company/invite/${inviteId}/`, "DELETE").then(() =>
    location.reload(),
  );
};

export function AcceptRejectButtons({ invite, isRequest, hide }) {
  const inviteId = invite.get("uid");
  if (hide) {
    return null;
  }
  if (isRequest) {
    return (
      <>
        <ActionButton
          text="Awaiting approval"
          onClickHandler={(e) => {
            alert(
              "This request is pending approval from a colleague. Contact your colleague or support for assistance in approving this request.",
            );
            // alertSuccess({
            //   title: "Requires approval from colleagues",
            //   text: `This request is pending approval from a colleague.
            //     Contact your colleague or support for assistance in approving this request.`,
            //   iconType: "warning"
            // });
          }}
        />
        <ActionButton
          color="danger"
          text="Delete"
          onClickHandler={(e) => {
            deleteInvite(invite);
          }}
        />
      </>
    );
  }

  return (
    <>
      <ActionButton
        color="success"
        text="Accept"
        onClickHandler={(e) => respondInvite(invite, true)}
      />
      <ActionButton
        color="danger"
        text="Reject"
        onClickHandler={(e) => respondInvite(invite, false)}
      />
    </>
  );
}

export default function CompanyInviteItem(props) {
  const { invite } = props;
  if (!invite) { return null }
  let isRequest = invite.get("is_request")
  return (
    <tr>
      <td scope="col">{isRequest ? "Request to join" : "Invitation to join"}</td>
      <td scope="col">{invite.getIn(["company", "name"])}</td>
      <td scope="col" className="text-right">
        <AcceptRejectButtons 
          {...props} 
          isRequest={isRequest} 
        />
      </td>
    </tr>
  );
}
